import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { VisitorLocationModel } from './visitor-location.model';

const API_URL = environment.apiUrl;

/**
 * Calls the backend's IP-based geo-location lookup (GET /visitor-location).
 * This reflects the visitor's assumed location, not a product's - it is used
 * purely as a locale fallback where no sales organization can be resolved
 * for a serial number (e.g. the not-sold-to-customer page).
 */
@Injectable({ providedIn: 'root' })
export class GeoLocationService {

  constructor(
    private http: HttpClient
  ) {
  }

  public getVisitorLocation(ipOverride?: string | null): Observable<VisitorLocationModel> {
    const url = ipOverride
      ? `${API_URL}/visitor-location?ip=${encodeURIComponent(ipOverride)}`
      : `${API_URL}/visitor-location`;
    return this.http.get<VisitorLocationModel>(url);
  }
}
